/**
 * Unauthorized Page
 * Displayed when a user is authenticated but has no assigned role/permissions
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/app/contexts/AuthContext';
import styles from './Unauthorized.module.scss';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const { signOut, userProfile } = useAuth();

  const handleSignOut = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <div className={styles.unauthorizedLayout}>
      <div className={styles.unauthorizedContainer}>
        <div className={styles.logo}>
          <img src="/logos/lore-icon-color.svg" alt="Lore" width={80} height={80} />
        </div>

        <div className={styles.contentBox}>
          <div className={styles.iconWrapper}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 8V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 16H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>

          <div className={styles.header}>
            <h1 className={styles.title}>Access Not Authorized</h1>
            <p className={styles.subtitle}>
              Your account has not been provisioned with access to the Rewards Admin dashboard.
            </p>
          </div>

          {userProfile && (
            <div className={styles.userInfo}>
              <span className={styles.label}>Signed in as:</span>
              <span className={styles.email}>{userProfile.email}</span>
            </div>
          )}

          <div className={styles.infoBox}>
            <strong>What to do next?</strong>
            <br />
            Contact the Rewards Squad to request access. They will assign you the appropriate role and permissions.
          </div>

          <div className={styles.actions}>
            <button
              type="button"
              onClick={handleSignOut}
              className={styles.signOutButton}
            >
              Sign Out
            </button>
          </div>
        </div>

        <footer className={styles.pageFooter}>
          <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
          <a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>
        </footer>
      </div>
    </div>
  );
};

export default Unauthorized;
